import React, { useState } from 'react';
import { toast } from 'sonner';
import { Card, CardContent } from './ui/card';
import { useAuth } from '../contexts/AuthContext';
import { NoahMascot } from './NoahMascot';
import { EXPRESSION_MODES, DEFAULT_EXPRESSION_MODE, NOAH_MOODS } from '../lib/noahMoods';
import { InfoTip } from './InfoTip';

export const NoahExpressionCard = () => {
  const { user, updateProfile } = useAuth();
  const current = user?.noah_expression || DEFAULT_EXPRESSION_MODE;
  const [saving, setSaving] = useState(null);

  const pick = async (value) => {
    if (value === current) return;
    setSaving(value);
    try {
      await updateProfile({ noah_expression: value });
      toast.success('Expresión de Noah actualizada');
    } catch {
      toast.error('No se pudo guardar');
    } finally {
      setSaving(null);
    }
  };

  const preview = EXPRESSION_MODES.find((m) => m.value === current);

  return (
    <Card className="bg-card/80 backdrop-blur border-white/10" data-testid="noah-expression-panel">
      <CardContent className="p-5 space-y-4">
        <div className="flex items-center gap-2">
          <h3 className="font-semibold text-foreground">Cómo se muestra Noah</h3>
          <InfoTip
            title="Expresiones de Noah"
            text="Tú decides la actitud de Noah en la app: sus poses 3D aparecen en pantallas vacías, al cerrar ventas y al escalar conversaciones."
            source="Tu perfil (campo noah_expression)"
          />
        </div>
        <p className="text-sm text-muted-foreground">
          Elige la personalidad visual de Noah. Se aplica en toda tu cuenta.
        </p>

        <div className="flex items-center gap-4 p-4 rounded-2xl bg-brand-deep">
          <NoahMascot mood={preview?.mood || 'chat'} size={90} forceMood />
          <div className="min-w-0">
            <p className="text-sm font-semibold text-brand-butter">{preview?.label || 'Automático'}</p>
            <p className="text-xs text-white/75">{preview?.desc}</p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
          {EXPRESSION_MODES.map((m) => {
            const active = m.value === current;
            return (
              <button
                key={m.value}
                onClick={() => pick(m.value)}
                disabled={saving === m.value}
                data-testid={`noah-expression-${m.value}`}
                className={`flex flex-col items-center gap-1 p-3 rounded-2xl border transition-colors ${
                  active
                    ? 'border-primary bg-primary/10 text-foreground'
                    : 'border-border bg-muted/30 text-muted-foreground hover:border-primary/50 hover:text-foreground'
                }`}
              >
                {m.mood ? (
                  <img src={NOAH_MOODS[m.mood].src} alt={m.label} className="h-12 w-auto" />
                ) : (
                  <div className="h-12 flex items-center text-xs">—</div>
                )}
                <span className="text-xs font-medium">{m.label}</span>
              </button>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default NoahExpressionCard;
